const actions = {
    SET_LOADING_PAIRS: 'SET_LOADING_PAIRS',

    GET_PAIRS: 'GET_PAIRS',
    GET_PAIRS_FAILED: 'GET_PAIRS_FAILED',
    GET_PAIRS_SUCCEEDED: 'GET_PAIRS_SUCCEEDED',
    initBiopairsData: () => ({ type: actions.GET_PAIRS }),
}

export default actions;